/**
 * Uses CtrlGroupDirective.js changing the template and transclude options.
 * The new template adds the input directly based on the inputCtrlType aspect instead of having
 * it transcluded.
 */
define(['text!./templates/input-ctrl.html', './CtrlGroupDirective', 'underscore'],
    (templateStr, CtrlGroupDirective, _)=> {
        return function () {
            const controlGroupDirectiveObj = new CtrlGroupDirective();
            controlGroupDirectiveObj.template = templateStr;
            controlGroupDirectiveObj.transclude = false;
            controlGroupDirectiveObj.scope.placeholder = '@?';

            const origLink = controlGroupDirectiveObj.link;
            controlGroupDirectiveObj.link = function (scope, element, attrs) {
                
                scope.availableValues = scope.model.aspects.availableValues;                
               
                // Checking for maxlength property and add 
                // maxlength attribute to the element
                if (attrs.maxlength != undefined){
                    scope.maxlength = attrs.maxlength;
                }
                                
                // Checking for filterCodes property
                if (scope.filterCodes != undefined){
                    
                    // Check if filterCodes is an array
                    // then remove those values from availableValues
                    if (!_.isUndefined(scope.filterCodes) && _.isArray(scope.filterCodes)){

                        scope.availableValues = _.filter(scope.availableValues, function (typeCode) {

                            return scope.filterCodes.indexOf(typeCode.code) === - 1;
                        });
                    }
                }
                
                origLink.apply(this, arguments);
                //The inputCtrlType aspect is created from the property metadata
                scope.metatype = scope.model.aspects.inputCtrlType;
            };
            return controlGroupDirectiveObj;
        };
    }
);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/basicinputs/InputCtrlDirective.js
 **/